/*
 * this was comply rewriten to not use jQuery. Based on the original jQuery plugin
 * Accessible Accordion system, using ARIA
 * @version v2.3.0
 * Website: https://a11y.nicolas-hoffmann.net/accordion/
 * License MIT: https://github.com/nico3333fr/jquery-accessible-accordion-aria/blob/master/LICENSE
 */

// orginal website used two classes for prefixClass and this not recomended.

// todo: fix keyboard support it's a bit half baked.

export default class Accordion {
  constructor(el, options) {
    const multiselectableValue = el.getAttribute('data-accordion-multiselectable');
    const prefixClassValue = el.getAttribute('data-accordion-prefix-classes');
    const directionEl = el.closest('[dir="rtl"]');

    const defaultConfig = {
      headersSelector: '.js-accordion__header',
      panelsSelector: '.js-accordion__panel',
      buttonsSelector: 'button.js-accordion__header',
      buttonSuffixId: '_tab',
      multiselectable: multiselectableValue === 'none',
      prefixClass: typeof (prefixClassValue) !== 'undefined' ? prefixClassValue : 'accordion',
      headerSuffixClass: '__title',
      buttonSuffixClass: '__header',
      panelSuffixClass: '__panel',
      direction: directionEl ? 'rtl' : 'ltr',
      accordionPrefixId: 'accordion',
    };

    // Merge default options with the ones set by the user
    this.options = { ...defaultConfig, ...options };

    this.$wrapper = el;
    this.panels = this.$wrapper.querySelectorAll(this.options.panelsSelector);

    this.initAttributes();
    this.initEvents();
  }

  initAttributes() {
    this.$wrapper.setAttribute('role', 'tablist');
    this.$wrapper.setAttribute('aria-multiselectable', this.options.multiselectable.toString());

    // Add class to the wrapper
    this.$wrapper.classList.add(...this.options.prefixClass.split(' '));

    if (!this.$wrapper.id) {
      this.$wrapper.id = `${this.options.accordionPrefixId}-${Math.random().toString(36).substr(2, 9)}`;
    }

    this.panels.forEach((panel, index) => {
      const header = panel.querySelector(this.options.headersSelector);

      // Create button
      const button = document.createElement('button');
      button.type = 'button';
      // copy the header content
      button.innerHTML = header.innerHTML;
      button.className = `${header.className} ${this.options.prefixClass}${this.options.buttonSuffixClass}`;

      header.setAttribute('tabindex', '0');
      // there might be more than one class name in
      header.classList.add(...`${this.options.prefixClass}${this.options.headerSuffixClass}`.split(' '));
      header.classList.add(`accordion${this.options.headerSuffixClass}`); // SynCK: Added so we can target all `__title`s

      panel.before(button);

      const panelId = panel.id || `${this.$wrapper.id}-${index}`;
      const buttonId = `${panelId}${this.options.buttonSuffixId}`;

      button.setAttribute('aria-controls', panelId);
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('role', 'tab');
      button.id = buttonId;
      button.setAttribute('tabindex', '-1');
      button.setAttribute('aria-selected', 'false');

      panel.setAttribute('aria-labelledby', buttonId);
      panel.setAttribute('role', 'tabpanel');

      // eslint-disable-next-line no-param-reassign
      panel.id = panelId;
      panel.setAttribute('aria-hidden', 'true');
      // yep this is gross, but it's a way to support multiple classes in the prefixClass even though there only should be one.
      panel.classList.add(...`${this.options.prefixClass}${this.options.panelSuffixClass}`.split(' '));

      if (panel.getAttribute('data-accordion-opened') === 'true') {
        button.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }

      if (index === 0) {
        button.removeAttribute('tabindex');
      }
    }, this);

    this.buttons = this.$wrapper.querySelectorAll(this.options.buttonsSelector);
  }

  initEvents() {
    this.$wrapper.querySelectorAll(this.options.buttonsSelector).forEach((button) => {
      button.addEventListener('focus', this.focusButtonEventHandler.bind(this), true);
      button.addEventListener('click', this.clickButtonEventHandler.bind(this));
      button.addEventListener('keydown', this.keydownButtonEventHandler.bind(this));
    });

    this.$wrapper.querySelectorAll(this.options.panelsSelector).forEach((panel) => {
      panel.addEventListener('keydown', this.keydownPanelEventHandler.bind(this));
    });
  }

  focusButtonEventHandler(e) {
    const button = e.target;

    this.buttons.forEach((btn) => {
      btn.setAttribute('tabindex', '-1');
      btn.setAttribute('aria-selected', 'false');
    });

    button.setAttribute('aria-selected', 'true');
    button.removeAttribute('tabindex');
  }

  clickButtonEventHandler(e) {
    const button = e.target;
    const panel = document.getElementById(button.getAttribute('aria-controls'));

    this.buttons.forEach((btn) => btn.setAttribute('aria-selected', 'false'));
    button.setAttribute('aria-selected', 'true');

    if (button.getAttribute('aria-expanded') === 'false') {
      button.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
    } else {
      button.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
    }

    // close all other panels

    // website is abusing the config a bit, so there is only one panel at time.
    // I believe the plugin wasn't desided this way, but does what we need it to do.
    if (!this.options.multiselectable) {
      this.panels.forEach((pnl) => { if (pnl !== panel) pnl.setAttribute('aria-hidden', 'true'); });
      this.buttons.forEach((btn) => { if (btn !== button) btn.setAttribute('aria-expanded', 'false'); });
    }

    setTimeout(() => button.focus(), 0);

    e.stopPropagation();
    e.preventDefault();
  }

  keydownButtonEventHandler(e) {
    const button = e.target;
    const firstButton = this.buttons[0];
    const lastButton = this.buttons[this.buttons.length - 1];
    const prevButton = button.previousElementSibling;
    const nextButton = button.nextElementSibling;
    let target = null;

    const k = this.options.direction === 'ltr' ? {
      prev: [38, 37], // up & left
      next: [40, 39], // down & right
      first: 36, // home
      last: 35, // end
    } : {
      prev: [38, 39], // up & left
      next: [40, 37], // down & right
      first: 36, // home
      last: 35, // end
    };

    const allKeyCode = [...k.prev, ...k.next, k.first, k.last];

    if (allKeyCode.includes(e.keyCode) && !e.ctrlKey) {
      this.buttons.forEach((btn) => {
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('aria-selected', 'false');
      });

      if (e.keyCode === 36) {
        target = firstButton;
      } else if (e.keyCode === 35) {
        target = lastButton;
      } else if (k.prev.includes(e.keyCode)) {
        target = button === firstButton ? lastButton : prevButton;
      } else if (k.next.includes(e.keyCode)) {
        target = button === lastButton ? firstButton : nextButton;
      }

      if (target) {
        this.goToHeader(target);
      }

      e.preventDefault();
    }
  }

  keydownPanelEventHandler(e) {
    const panel = e.target.closest(this.options.panelsSelector);
    const button = document.getElementById(panel.getAttribute('aria-labelledby'));
    const firstButton = this.buttons[0];
    const lastButton = this.buttons[this.buttons.length - 1];
    const prevButton = button.previousElementSibling;
    const nextButton = button.nextElementSibling;
    let target = null;

    if (e.keyCode === 38 && e.ctrlKey) {
      target = button;
    } else if (e.keyCode === 33 && e.ctrlKey) {
      target = button === firstButton ? lastButton : prevButton;
    } else if (e.keyCode === 34 && e.ctrlKey) {
      target = button === lastButton ? firstButton : nextButton;
    }

    if (target) {
      this.goToHeader(target);
      e.preventDefault();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  goToHeader(target) {
    if (!target) return;

    target.setAttribute('aria-selected', 'true');
    target.removeAttribute('tabindex');

    setTimeout(() => target.focus(), 0);
  }
}
